import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';

import { getStakeholdersByRole } from '@/selectors/merchant';
import Stakeholders from './SummaryStakeholdersByType';

const tKey = 'products-fe.pages.summary_page.main.stakeholders';

const SummaryStakeholders = ({ type, role, stakeholders }) =>
  stakeholders && stakeholders.length ? (
    <>
      <Typography textToken="text-style/headings/titles/bold/grande">
        <Message path={`${tKey}.${role.toLowerCase()}.title`} />
      </Typography>
      <Stakeholders type={type} stakeholders={stakeholders} role={role} />
    </>
  ) : (
    ''
  );

SummaryStakeholders.propTypes = {
  role: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  stakeholders: PropTypes.array,
};

export default connect((state, { role }) => ({
  stakeholders: getStakeholdersByRole(role)(state),
}))(SummaryStakeholders);
